import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MatOption, MatOptionSelectionChange } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Subject, ReplaySubject, debounceTime, takeUntil } from 'rxjs';
import {
  MAX_MULTI_ALL_EXPAND,
  allModeControlValue,
  boundedAllValues,
  limitRenderedOptions,
  multiSelectAllTriggerLabel,
  selectableValueCount,
} from 'src/app/modules/shared/utils/multi-select-all-trigger.util';

@Component({
  selector: 'app-customer-level-drop-down',
  templateUrl: './customer-level-drop-down.component.html',
  styleUrls: ['./customer-level-drop-down.component.scss']
})
export class CustomerLevelDropDownComponent implements OnInit {
  @Input() formDetails: any = {};

  @Input() selectedValues: any = {};
  @Input() reset: number = 0;

  @Output() onSelectFilter: any = new EventEmitter<any>();
  searchUserForm!: FormGroup;
  private readonly ALL_TOKEN = 'All';
  private readonly filterEmit$ = new Subject<{ type: string; value: any }>();

  @ViewChild('allEngineSelected') private allEngineSelected!: MatOption;
  @ViewChild('allDisSelected') private allDisSelected!: MatOption;
  @ViewChild('allCertificationSelected') private allCertificationSelected!: MatOption;
  @ViewChild('allCustomerSelected') private allCustomerSelected!: MatOption;
  @ViewChild('allEccSelected') private allEccSelected!: MatOption;
  @ViewChild('allLobSelected') private allLobSelected!: MatOption;
  @ViewChild('allProductBuSelected') private allProductBuSelected!: MatOption;
  @ViewChild('allRegionSelected') private allRegionSelected!: MatOption;

  @ViewChild('Customer', { read: MatSelect }) private customerSelect?: MatSelect;
  @ViewChild('engine', { read: MatSelect }) private engineSelect?: MatSelect;
  @ViewChild('Displacement', { read: MatSelect }) private displacementSelect?: MatSelect;
  @ViewChild('Certification', { read: MatSelect }) private certificationSelect?: MatSelect;
  @ViewChild('ecc', { read: MatSelect }) private eccSelect?: MatSelect;
  @ViewChild('lob', { read: MatSelect }) private lobSelect?: MatSelect;
  @ViewChild('ProductBu', { read: MatSelect }) private productBuSelect?: MatSelect;

  public searchEcc: FormControl = new FormControl();
  public searchEngine: FormControl = new FormControl();
  public searchDis: FormControl = new FormControl();
  public searchCert: FormControl = new FormControl();
  public searchCustomer: FormControl = new FormControl();
  public searchLob: FormControl = new FormControl();
  public searchProductBu: FormControl = new FormControl();
  public searchRegion: FormControl = new FormControl();

  protected _onDestroy = new Subject<void>();

  public filteredEngine: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredDis: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredCert: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredEcc: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredCustomer: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredLob: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredProductBu: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredRegion: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  data: any;
  private publishOptions(
    subject: ReplaySubject<any[]>,
    list: any[] | null | undefined
  ): void {
    subject.next(limitRenderedOptions(list));
  }
  path = location.pathname;
  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) { }
  ngAfterViewInit(): void {

    this.filterEmit$
      .pipe(debounceTime(600), takeUntil(this._onDestroy))
      .subscribe((payload) => this.onSelectFilter.emit(payload));

    this.expandAllSelectionsIfNeeded();


  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.formDetails) {
      this.publishOptions(this.filteredEngine, this.formDetails['engine_model']?.slice(1));
      this.publishOptions(this.filteredDis, this.formDetails['displacement']?.slice(1));
      this.publishOptions(this.filteredCert, this.formDetails['certification']?.slice());
      this.publishOptions(this.filteredEcc, this.formDetails['ecc']?.slice());
      this.publishOptions(this.filteredCustomer, this.formDetails['master_customer_name']?.slice());
      this.publishOptions(this.filteredLob, this.formDetails['lob_l2']?.slice());
      this.publishOptions(this.filteredProductBu, this.formDetails['current_product_bu']?.slice());
    }
    if (this.reset > 0) {
      this.data.type = '';
      this.searchUserForm.controls.userDisplacement.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userCertification.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userCustomer.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userEngine.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userEcc.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userLob.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userProductBu.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userRegion.patchValue([this.ALL_TOKEN]);

      this.reset = 0;
    }

    this.expandAllSelectionsIfNeeded();
  }
  ngOnInit(): void {
    this.searchUserForm = this.fb.group({
      userEngine: new FormControl([this.ALL_TOKEN]),
      userDisplacement: new FormControl([this.ALL_TOKEN]),
      userCertification: new FormControl([this.ALL_TOKEN]),
      userCustomer: new FormControl([this.ALL_TOKEN]),
      userEcc: new FormControl([this.ALL_TOKEN]),
      userLob: new FormControl([this.ALL_TOKEN]),
      userProductBu: new FormControl([this.ALL_TOKEN]),
      userRegion: new FormControl([this.ALL_TOKEN]),
    });
    setTimeout(() => this.expandAllSelectionsIfNeeded(), 0);


    this.searchEngine.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEngine();
      });
    this.searchDis.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDis();
      });
    this.searchCert.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCert();
      });
    this.searchEcc.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEcc();
      });
    this.searchCustomer.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCustomer();
      });
    this.searchLob.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterLob();
      });
    this.searchProductBu.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProductBu();
      });
    this.searchRegion.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRegion();
      });
  }

  protected filterRegion() {
    const list = this.formDetails?.['region'];
    if (!Array.isArray(list)) return;

    let search = this.searchRegion.value;
    if (typeof search !== 'string') search = '';
    search = search.toLowerCase();

    this.publishOptions(this.filteredRegion, 
      list.filter((item) => item?.value?.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterProductBu() {
    // get the search keyword
    let search = this.searchProductBu.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredProductBu, 
      this.formDetails['current_product_bu'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterLob() {
    // get the search keyword
    let search = this.searchLob.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredLob, 
      this.formDetails['lob_l2'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }


  protected filterEngine() {
    // get the search keyword
    let search = this.searchEngine.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredEngine, 
      this.formDetails['engine_model'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterCert() {
    // get the search keyword
    let search = this.searchCert.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredCert, 
      this.formDetails['certification'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterDis() {
    // get the search keyword
    let search = this.searchDis.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredDis, 
      this.formDetails['displacement'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterEcc() {
    // get the search keyword
    let search = this.searchEcc.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredEcc, 
      this.formDetails['ecc'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterCustomer() {
    // get the search keyword
    let search = this.searchCustomer.value;

    search = search.toLowerCase();
    // filter
    this.publishOptions(this.filteredCustomer, 
      this.formDetails['master_customer_name'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }



  changeFilter(event, filter) {
    const controlName = this.getControlName(filter);
    const allValues = boundedAllValues(this.formDetails?.[filter], this.ALL_TOKEN);
    const raw: string[] = Array.isArray(event) ? event : [];

    let { controlValue } = this.normalizeSelection(raw, allValues);
    controlValue = this.collapsePartialAllToken(controlValue, allValues);
    const emittedValue = this.deriveEmittedMulti(controlValue, filter);

    if (controlName && this.searchUserForm?.controls?.[controlName]) {
      this.searchUserForm.controls[controlName].setValue([...controlValue], {
        emitEvent: false,
      });
    }

    this.scheduleAllMatOptionSync(filter);

    this.data = { value: emittedValue, type: filter };
    this.filterEmit$.next(this.data);
  }

  multiSelectTriggerLabel(filter: string): string {
    const controlName = this.getControlName(filter);
    if (!controlName) return '';
    const raw = this.searchUserForm?.controls?.[controlName]?.value;
    return multiSelectAllTriggerLabel(
      raw,
      this.formDetails?.[filter],
      this.ALL_TOKEN
    );
  }

  /** When the panel opens, fix inconsistent ["All", ...partial] and re-sync the "All" row. */
  onFilterMultiOpened(isOpen: boolean, filter: string): void {
    if (!isOpen) return;
    const controlName = this.getControlName(filter);
    if (!controlName || !this.searchUserForm?.controls?.[controlName]) return;
    const allValues = boundedAllValues(this.formDetails?.[filter], this.ALL_TOKEN);
    let controlValue =
      (this.searchUserForm.controls[controlName].value as string[]) || [];
    controlValue = this.collapsePartialAllToken([...controlValue], allValues);
    this.searchUserForm.controls[controlName].setValue([...controlValue], {
      emitEvent: false,
    });
    this.scheduleAllMatOptionSync(filter);
  }

  onAllOptionSelectionChange(change: MatOptionSelectionChange, filter: string) {
    if (!change?.isUserInput) return;
    const controlName = this.getControlName(filter);
    if (!controlName) return;

    const allValues = boundedAllValues(this.formDetails?.[filter], this.ALL_TOKEN);
    const control = this.searchUserForm.controls[controlName];
    if (!control) return;

    if (change.source.selected) {
      control.setValue(allModeControlValue(allValues, this.ALL_TOKEN), { emitEvent: false });
      this.data = { type: filter, value: [this.ALL_TOKEN] };
      this.filterEmit$.next(this.data);
      this.scheduleAllMatOptionSync(filter);
    } else {
      control.setValue([], { emitEvent: false });
      this.data = { type: filter, value: [] };
      this.filterEmit$.next(this.data);
      this.scheduleAllMatOptionSync(filter);
    }
  }

  private expandAllSelectionsIfNeeded() {
    this.expandAllFor('master_customer_name');
    this.expandAllFor('engine_model');
    this.expandAllFor('displacement');
    this.expandAllFor('certification');
    this.expandAllFor('ecc');
    this.expandAllFor('lob_l2');
    this.expandAllFor('current_product_bu');
  }

  private expandAllFor(filter: string) {
    const controlName = this.getControlName(filter);
    if (!controlName) return;
    const control = this.searchUserForm?.controls?.[controlName];
    if (!control) return;

    const current: string[] = control.value || [];
    // Only act on "All" mode. Partial selections (no "All" token) stay as-is.
    if (!current.includes(this.ALL_TOKEN)) return;

    const optionCount = selectableValueCount(
      this.formDetails?.[filter],
      this.ALL_TOKEN
    );
    // UAT lists are large enough that selecting every value freezes the page.
    if (optionCount === 0 || optionCount > MAX_MULTI_ALL_EXPAND) {
      if (optionCount > MAX_MULTI_ALL_EXPAND && current.length !== 1) {
        control.setValue([this.ALL_TOKEN], { emitEvent: false });
        this.scheduleAllMatOptionSync(filter);
      }
      return;
    }

    const allValues = boundedAllValues(this.formDetails?.[filter], this.ALL_TOKEN);
    if (allValues.length === 0) return;

    const target = allModeControlValue(allValues, this.ALL_TOKEN);
    if (this.arraysEqual(current, target)) return;

    control.setValue(target, { emitEvent: false });
    this.scheduleAllMatOptionSync(filter);
  }

  private getControlName(filter: string): string | null {
    switch (filter) {
      case 'master_customer_name':
        return 'userCustomer';
      case 'engine_model':
        return 'userEngine';
      case 'displacement':
        return 'userDisplacement';
      case 'certification':
        return 'userCertification';
      case 'ecc':
        return 'userEcc';
      case 'lob_l2':
        return 'userLob';
      case 'current_product_bu':
        return 'userProductBu';
      default:
        return null;
    }
  }

  private getAllValues(filter: string): string[] {
    const list = this.formDetails?.[filter];
    if (!Array.isArray(list)) return [];
    return list
      .map((i: any) => i?.value)
      .filter((v: any) => typeof v === 'string' && v !== this.ALL_TOKEN);
  }

  /** Mat-select can leave the extra "All" row ticked after patchValue; sync after the next paint. */
  private scheduleAllMatOptionSync(filter: string): void {
    const run = () => {
      this.applyAllMatOptionSync(filter);
      this.cdr.detectChanges();
    };
    setTimeout(run, 0);
    setTimeout(run, 16);
    setTimeout(run, 64);
  }

  /** True when the form value represents every option (expanded "All" or lone All before expand). */
  private shouldAllMatOptionBeSelected(
    filter: string,
    controlValue: string[]
  ): boolean {
    if (!controlValue?.length) return false;
    if (controlValue.length === 1 && controlValue[0] === this.ALL_TOKEN) {
      return true;
    }
    const allVals = this.getAllValues(filter);
    if (allVals.length === 0) {
      return false;
    }
    return (
      controlValue.includes(this.ALL_TOKEN) &&
      controlValue.length === allVals.length + 1
    );
  }

  private applyAllMatOptionSync(filter: string): void {
    const controlName = this.getControlName(filter);
    if (!controlName) return;
    const controlValue =
      (this.searchUserForm?.controls?.[controlName]?.value as string[]) ?? [];
    const wantSelect = this.shouldAllMatOptionBeSelected(filter, controlValue);
    const matSelect = this.getMatSelectForFilter(filter);
    if (matSelect?.options?.length) {
      matSelect.options.forEach((opt) => {
        if (opt.value !== this.ALL_TOKEN) return;
        if (wantSelect) {
          if (!opt.selected) opt.select();
        } else if (opt.selected) {
          opt.deselect();
        }
      });
      return;
    }
    const opt = this.getAllMatOption(filter);
    if (!opt) return;
    if (wantSelect) {
      if (!opt.selected) opt.select();
    } else if (opt.selected) {
      opt.deselect();
    }
  }

  /** If "All" is in the value but not every option is selected, drop the token. */
  private collapsePartialAllToken(
    controlValue: string[],
    allValues: string[]
  ): string[] {
    if (!Array.isArray(controlValue) || allValues.length === 0) {
      return Array.isArray(controlValue) ? [...controlValue] : [];
    }
    if (!controlValue.includes(this.ALL_TOKEN)) {
      return [...controlValue];
    }
    const nonAll = controlValue.filter((v) => v !== this.ALL_TOKEN);
    // Lone ["All"] means "all selected" (not yet expanded); never strip it to [].
    if (nonAll.length > 0 && nonAll.length < allValues.length) {
      return [...nonAll];
    }
    return [...controlValue];
  }

  private deriveEmittedMulti(
    controlValue: string[],
    filter: string
  ): string[] {
    if (this.shouldAllMatOptionBeSelected(filter, controlValue)) {
      return [this.ALL_TOKEN];
    }
    return controlValue.filter((v) => v !== this.ALL_TOKEN);
  }

  private getMatSelectForFilter(filter: string): MatSelect | null {
    switch (filter) {
      case 'master_customer_name':
        return this.customerSelect ?? null;
      case 'engine_model':
        return this.engineSelect ?? null;
      case 'displacement':
        return this.displacementSelect ?? null;
      case 'certification':
        return this.certificationSelect ?? null;
      case 'ecc':
        return this.eccSelect ?? null;
      case 'lob_l2':
        return this.lobSelect ?? null;
      case 'current_product_bu':
        return this.productBuSelect ?? null;
      default:
        return null;
    }
  }

  private getAllMatOption(filter: string): MatOption | null {
    switch (filter) {
      case 'master_customer_name':
        return this.allCustomerSelected ?? null;
      case 'engine_model':
        return this.allEngineSelected ?? null;
      case 'displacement':
        return this.allDisSelected ?? null;
      case 'certification':
        return this.allCertificationSelected ?? null;
      case 'ecc':
        return this.allEccSelected ?? null;
      case 'lob_l2':
        return this.allLobSelected ?? null;
      case 'current_product_bu':
        return this.allProductBuSelected ?? null;
      default:
        return null;
    }
  }

  private normalizeSelection(
    raw: string[],
    allValues: string[]
  ): { controlValue: string[]; emittedValue: string[] } {
    const hasAll = raw.includes(this.ALL_TOKEN);

    if (hasAll && raw.length === 1) {
      return {
        controlValue: allModeControlValue(allValues, this.ALL_TOKEN),
        emittedValue: [this.ALL_TOKEN],
      };
    }

    if (hasAll && raw.length > 1 && raw.length < allValues.length + 1) {
      const subset = raw.filter((v) => v !== this.ALL_TOKEN);
      return { controlValue: subset, emittedValue: subset };
    }

    const withoutAll = raw.filter((v) => v !== this.ALL_TOKEN);
    if (!hasAll && allValues.length > 0 && withoutAll.length === allValues.length) {
      return {
        controlValue: allModeControlValue(allValues, this.ALL_TOKEN),
        emittedValue: [this.ALL_TOKEN],
      };
    }

    if (hasAll && raw.length === allValues.length + 1) {
      return {
        controlValue: allModeControlValue(allValues, this.ALL_TOKEN),
        emittedValue: [this.ALL_TOKEN],
      };
    }

    return { controlValue: withoutAll, emittedValue: withoutAll };
  }

  private arraysEqual(a: string[], b: string[]) {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    const sa = [...a].sort();
    const sb = [...b].sort();
    for (let i = 0; i < sa.length; i++) {
      if (sa[i] !== sb[i]) return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.filterEmit$.complete();
  }
}
